import { scrn_md, $docContainer, $header, CurrentPage } from './ProjectVars';

let header_height = $docContainer.outerWidth() > scrn_md ? 122.5 : 134; //"reasonable" defaults based on browser calculated header height values when ath button is not being displayed
let header_width = $header.css('width').match(/([0-9]+)px/i)[1];

export const setHeaderHeight = () => {
    header_height = getHeaderHeight();
    // div.topContainer has a height of 1px when it is not showing, compensating for that
    if (pId === 130 && CurrentPage !== 'homePage') {
        header_height = header_height - 1;
    }

    $j('section#content').css('padding-top', `${header_height}px`);
};

export const getHeaderHeight = () => {
    return +$header.css('height').match(/([0-9]+)px/i)[1];
};

export const setHeaderWidth = () => {
    header_width = getHeaderWidth();
    $header.css('width', `${header_width}px`);
};

export const getHeaderWidth = () => {
    return $j('#content').innerWidth();
};